import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomPriceRank_RoomPriceRankPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchRoomPriceRank = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(RoomPriceRank_RoomPriceRankPage_Query, { variables: { hotelID } });

	return {
		data,
	};
};
